import "core-js/modules/es.array.push.js";
import { ref, computed, inject } from "vue";
import axios from "axios";
import { useStore, mapState, mapMutations } from "vuex";
import { ElNotification } from "element-plus";
export default {
  data() {
    return {
      loading: false,
      loadingFetch: false,
      paths: [{
        name: "Профиль",
        path: "/rol-shop/profile"
      }, {
        name: "Адрес доставки",
        path: "/rol-shop/profile/address"
      }, {
        name: "Добавление адреса доставки",
        path: "/rol-shop/map"
      }],
      result: [],
      rules: {
        address: [{
          required: true,
          message: "Нужно заполнить!",
          trigger: "blur"
        }, {
          min: 5,
          message: "Слишком короткий!",
          trigger: "blur"
        }, {
          validator: this.checkGeo,
          trigger: "submit"
        }, {
          validator: this.checkSelect,
          trigger: "submit"
        }]
      }
    };
  },
  methods: {
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchAddressSelect(value, cb) {
      try {
        this.checkFromSelect = false;
        if (value) {
          const {
            data
          } = await axios.get(`https://suggest-maps.yandex.ru/v1/suggest?apikey=00748542-2e0b-439d-864b-98b4baac2c5f&text=${value}&bbox=${this.area}&lang=ru_RU&strict_bounds=1&print_address=1`);
          this.result = data.results.map(item => ({
            address: item.address.formatted_address,
            house: item.address.component.find(pl => pl.kind == "HOUSE") ? item.address.component.find(pl => pl.kind == "HOUSE").name : "",
            city: item.address.component.find(pl => pl.kind == "LOCALITY") ? item.address.component.find(pl => pl.kind == "LOCALITY").name : "",
            miniAddress: item.address.component.filter(item => ["HOUSE", "STREET", "VEGETATION", "DISTRICT", "METRO"].includes(item.kind[0]))
          }));
          // возвращение данных
          cb(this.result);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchAddress() {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/address`);
        this.address = data;
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        this.loading = false;
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    },
    async postAddress() {
      let apiRes = null;
      let repeat = false;
      try {
        this.loading = true;
        let joinAddress = this.miniAddress.map(item => item.name).join(", ");
        if (!this.repeatAddress(joinAddress, this.form.house, this.form.input, this.form.floor, this.form.apartment, this.city)) {
          const {
            data
          } = await axios.post(`https://c2ff7a8de0a119c8.mokky.dev/address`, {
            address: joinAddress,
            house: this.form.house,
            input: this.form.input,
            floor: this.form.floor,
            apartment: this.form.apartment,
            city: this.city
          });
        } else {
          // notif
          this.openNotif("error", "Ошибка!", "Такой адрес уже есть в сохраненных");
          repeat = true;
        }
        this.form.address = "";
        this.form.house = "";
        this.form.input = "";
        this.form.floor = "";
        this.form.apartment = "";
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        this.fetchAddress();
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
        if (!repeat) {
          this.openNotif("success", "Успех!", "Ваш адрес успешно сохранен!");
        }
      }
    },
    handleSelect(item) {
      // заполнение полей
      this.form.address = item.address;
      this.form.house = item.house;

      // сохранение города
      this.city = item.city;

      // сохранение адреса без города
      this.miniAddress = item.miniAddress;

      // перемещение по карте
      this.$refs.Map.moveMap(item.address);

      // проверка что адрес был выбран из списка или карты
      this.checkFromSelect = true;
    },
    sumbitForm(forName) {
      forName.validate(valid => {
        if (valid) {
          this.postAddress();
        } else {
          return false;
        }
      });
    },
    repeatAddress(address, house, input, floor, apartment, city) {
      for (let item of this.address) {
        if (item.address === address && item.house === house && item.input === input && item.floor === floor && item.apartment === apartment && item.city === city) {
          return true;
        }
      }
      return false;
    },
    openNotif(reason, title, message) {
      if (reason === "error") {
        ElNotification.error({
          title: title,
          message: message,
          showClose: false
        });
      }
      if (reason === "success") {
        ElNotification.success({
          title: title,
          message: message,
          showClose: false
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setPaths(vm.paths);
    });
  },
  computed: {
    ...mapState({
      loadingDeliveryCheck: state => state.map.loading,
      loadingAddress: state => state.map.loadingAddress
    })
  },
  mounted() {
    this.fetchAddress();
  },
  setup() {
    const store = useStore();
    var arrayCoord = computed(() => store.state.map.arrayCoord);
    var deliveryPossible = computed(() => store.state.map.deliveryPossible);
    const {
      area,
      address
    } = inject("address");
    const form = ref({
      address: "",
      house: "",
      input: "",
      floor: "",
      apartment: ""
    });
    const ruleFormRef = ref();
    const loadingGeocoder = ref(false);
    var checkFromSelect = ref(false);
    const city = ref();
    const miniAddress = ref();
    const geocoderCoord = async (lat, long) => {
      try {
        loadingGeocoder.value = true;
        form.value.address = "";
        form.value.house = "";
        const {
          data
        } = await axios.get(`https://geocode-maps.yandex.ru/1.x/?apikey=37720b8b-dc03-4346-b6a4-3ae3458e9af6&geocode=${lat},${long}&format=json&lang=ru_RU`);
        const path = data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData;

        // заполнение полей адреса и дом
        if (path.kind == "house") {
          form.value.house = path.Address.Components.find(item => item.kind == "house").name;
        }
        const filteredArray = path.Address.Components.filter(item => ["street", "metro", "district", "area", "province", "railway_station", "station", "vegetation", "other", "house"].includes(item.kind));
        const names = filteredArray.map(item => item.name).join(", ");
        // адрес с карты в инпут
        form.value.address = names;

        // город
        let isCity = path.Address.Components.filter(item => item.kind === "locality");
        if (isCity.length > 0) {
          city.value = isCity[0].name;
        }

        // адрес без города
        let isAddress = path.Address.Components.filter(item => ["street", "metro", "district", "railway_station", "station", "vegetation", "house"].includes(item.kind));
        if (isAddress.length > 0) {
          miniAddress.value = isAddress;
        }

        // проверка что адрес был выбран из списка или карты
        checkFromSelect.value = true;
      } catch (err) {
        console.log(err);
      } finally {
        loadingGeocoder.value = false;
      }
    };

    // проверка адреса на доступность для доставки
    const checkGeo = (rule, value, callback) => {
      let possible = false;
      store.dispatch("map/geocoderAddress", value).then(() => {
        store.dispatch("map/checkAddress", {
          lat: arrayCoord.value[0],
          long: arrayCoord.value[1]
        }).then(() => {
          possible = deliveryPossible.value;
          if (value && !possible) {
            callback(new Error("Доставка по этому адресу не осуществляется!"));
          } else {
            callback();
          }
        });
      });
    };

    // проверка что адрес был выбран из списка или карты
    const checkSelect = (rule, value, callback) => {
      if (!checkFromSelect.value) {
        callback(new Error("Адрес не выбран!"));
      } else {
        callback();
      }
    };
    return {
      geocoderCoord,
      form,
      ruleFormRef,
      checkGeo,
      checkSelect,
      loadingGeocoder,
      checkFromSelect,
      city,
      miniAddress,
      area,
      address
    };
  }
};